<template>
    <div>
        <el-dialog
        title="会员来源筛选"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose">
            <div class="content">
                <el-form ref="form" :model="query" label-width="80px">
                    <el-form-item label="" style="text-align: center;">
                        <el-radio-group @change="selectRes" v-model="form.resource">
                        <el-radio label="1">小程序</el-radio>
                        <el-radio label="2">自然注册</el-radio>
                        <el-radio label="3">自定义渠道</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <!-- <el-form-item v-if="form.resource!=3">
                        <el-input placeholder="请输入关键词搜索标签"  v-model="query.keyword_search" @change="getList">
                            <i  slot="suffix" class="el-icon-search"></i>
                        </el-input>
                    </el-form-item> -->
                </el-form>
                <ul class="list" v-if="form.resource!=2">
                    <li v-for="(item,index) in listLabel" :key='index'>
                        <!-- <p class="title">{{item.group_name}}</p> -->
                        <div class="l"  ref="desc">
                            <span @click="checkLabel(t)" :class="isCheck(t.id) ? 'active' : ''"  v-for="(t,i) in item.tag" :key='i'>{{t.name}}</span>
                        </div>
                        <!-- <p class="zs" @click="item.status = !item.status" v-if="item.idShowText">
                            <span v-if="item.status">展开 <i class="el-icon-arrow-down"></i></span>
                            <span v-else>收回<i class="el-icon-arrow-up"></i></span>
                        </p> -->
                    </li>
                </ul>
                <ul v-if="form.resource==2" >
                    <li style="margin-top:60px;text-align:center;">选择“自然注册”后，将筛选出通过自然注册小程序与APP的客户～</li>
                </ul>
                <div class="cliear" >
                    <span v-if="form.resource!=2">已选中 <span style="color:#327EFF;padding:0;">{{form.tags.length}}</span> 个类型</span>

                    <el-button v-if="form.resource!=2" class="clear" type="text" @click="clera">清 空</el-button>
                    <!-- <el-button v-if="types!=4" type="text" @click="addLabel">添加标签</el-button> -->
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" >取 消</el-button>
                <el-button type="primary" @click="goType(2)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
const  QUERY={
  keyword_search:""
}
export default {
    props:{
        types:{
            type:Number,
            default:1
        }
        // isRadio
    },
    data() {
        return {
            dialogVisible:false,
            isRadio:"",
            query:JSON.parse(JSON.stringify(QUERY)),
            form:{
                resource:"1",
                tags:[]
            },
            listLabel:[
                {
                    group_name:"来源标签",
                    status:true,
                    idShowText:true,
                    tag:[{name:"渠道名称1",id:1},{name:"名称",id:2},{name:"渠道名称1",id:3},{name:"渠道名称",id:4},{name:"渠道名称",id:4},{name:"渠道名称1",id:4}]
                }
            ],
            textHeight:null
        }
    },
    computed:{
        isCheck(){
            return function(id){
                console.log(id,1111)
                if(id==1){
                    return true;
                }
                // let is=false;
                // this.form.tags.forEach(item=>{
                // if(item.id==id){
                //     is=true;
                // }
                // })
                // return is;
            }
        
        }
    },
    mounted(){
        console.log("开始咯")
        // this.calculateText();
        // this.form.resource=1;
    },
    methods: {
        handleClose(e){
            this.dialogVisible=false;
        },
        addLabel(){},
        selectRes(){

        },
        show(){
            this.dialogVisible=true;
        },
        clera(){
            this.form.tags=[];
        },
        checkLabel(t){
        // let index=this.form.tags.findIndex(item=>item.id==t.id);
        // if(index!=-1){
        //     this.form.tags.splice(index,1);
        // }else{
        //     this.form.tags.push({name:t.name,id:t.id});
        // }
        
        },
        selectRes(){
        },
        calculateText() {
        // 这是默认两行数据的高度，一行的高度可以自定义 可以*3 *4达到三行或者四行显示展示和收起的效果
        let twoHeight = 26 * 3;
        this.textHeight = `${twoHeight}px`;
        let l=this.$refs.desc;
        for(let i=0;i<l.length;i++){
            let index=l[i].dataset.index;
            let idx=l[i].dataset.i;
            let curHeight = l[i].offsetHeight;
            let d=this.listLabel[i];
            if (curHeight > twoHeight) {
            d.status = true;
            d.idShowText = true;
            } else {
            d.status = false;
            d.idShowText = false;
            }
        }
        },
        async getList(){
        // if(this.isRadio==1){
        //     var {result} = await CustomerTag(1,this.query);
        // }else if(this.isRadio==2){
        //     var {result} = await CustomerGroupTag(1,this.query);
        // }
        
        // if(result){
        //     result.forEach(item=>{
        //     item['status']=false;
        //     item['idShowText']=false;
        //     })
        //     this.form.tags=[];
        //     this.listLabel=result;
        //     setTimeout(() => {
        //     this.calculateText();
        //     }, 300);
        // }
        },
        set(){
            return this.form.tags
        }
    },
}
</script>
<style lang="less" scoped>
.dialog-footer{
    display: block;
    
    .el-button{
        border-radius: 30px;
    }
}
.active{
    background: #327EFF !important;
    color:#fff !important;
}
/deep/ .el-radio{
  margin-right:120px;
  &:last-child{
      margin:0;
  }
}
/deep/ .el-dialog__footer{
        border-top:1px solid #ededed;
        padding: 10px 50px 20px;
}
.clasCk{
    color: #fff !important;
    background: #258EF7 !important;
    border: 0px !important;
}
 .openSpan {
    position: absolute;
    right: 0;
    bottom: -4px;
  }
   .titleText {
    // font-weight: bold;
    font-size: 14px;
    line-height: 28px;
  }
  .openClose {
    font-size: 14px;
    color: #258EF7;
  }
  .openSpan {
    position: absolute;
    right: 0;
    bottom: -4px;
  }
  .statusText {
    overflow: hidden;
    display: block;
  }
  .statusText:after {
    content: "...";
    position: absolute;
    bottom: 0;
    right: 2px;
    width: 48px;
    padding-left: 30px;
    background: linear-gradient(to right, rgba(255,255,255,0.2), #fff 45%);
  }


.txt{
    padding:30px;
    span{
        color:#258EF7;
    }
}

.content{
    position: relative;
    padding:30px;
  height:300px;
  overflow-y: auto;
}
/deep/ .el-form-item__content{
    margin-left:0 !important;
}
/deep/ .el-input .el-input__inner{
  border-radius: 30px;
  background: #F1F1F1;
}
.list{
    .title{
        padding-bottom:10px;
    }
    .l{
        span{
            margin-right: 15px;
            margin-bottom: 15px;
            display: inline-block;
            padding:5px 20px;
            background: #F6F6F9;
            border-radius: 15px;
            border: 1px solid #DBDFE6;
            color: #777777;
        }
    }
    .zs{
        margin-top:15px;
        text-align: center;
        color:#1890FF;
    }
}
.staff-model {
  position: relative;
}
.cliear{
    position: absolute;
    bottom:8px;
    left:30px;
    span{
        padding-right:15px;
    }
    .clear.el-button{
        color:#999;
    }
}
</style>